import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";

const RadioBoxGroup = ({ label, name, value, onChange, options, disabled }) => {
  return (
    <FormControl disabled={disabled}>
      {label && <FormLabel>{label}</FormLabel>}
      <RadioGroup row name={name} value={value} onChange={onChange}>
        {options.map((option, i) => (
          <FormControlLabel
            key={i}
            value={option.value}
            control={<Radio />}
            label={option.label}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "14px",
              },
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioBoxGroup;
